import React, { useState, useEffect, useContext } from "react";
import { useHistory, Link } from "react-router-dom";
import { Button, Icon, Modal } from "semantic-ui-react";
import { auth } from "../../Firebase";
import { HeaderProps } from "./structs";
import api from "../../Service/Api";
import backend from "../../Service/Backend";
import ProgressLoader from "../Common/ProgressLoader";
import { ROLES } from "../../Utils/constants";
import { storage } from "../../Firebase/firebase";
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Upload, notification } from 'antd';
import { ChevronLeft } from "@material-ui/icons";
import filterIcon from '../../Images/filter_header.svg';
import useCheckMobileScreen, {
  useCheckTabScreen,
} from "../../hooks/useCheckMobileScreen";
import { MobileFooter as MobileHeaderTabs} from "./Footer";
import { ref, uploadBytesResumable } from "firebase/storage";
import { AppContext } from "../../context/appContext";
import ClientList from "./ClientList";
import { get, getDecodedToken } from "../../Utils/helpers";
import CryptoJS from 'crypto-js';
import HeaderMenuButton from "../Common/HeaderMenuButton";
import AccountMenu from "./AccountMenu";

const { VITE_REACT_APP_BACKEND_MYSQL, VITE_REACT_APP_DEFAULT_CLIENT_ID, VITE_REACT_APP_PLATFORM_ADMIN } = import.meta.env;

const START_APP_ACCESS_USERS: string[] = [ROLES.OFFICE_MANAGER, ROLES.RELATIONSHIP_MANAGER, ROLES.PARTNER, ROLES.OFFICE_ADMIN, ROLES.UNDER_WRITER]

const SEND_APP_ACCESS_USERS: string[] = [ROLES.OFFICE_MANAGER, ROLES.RELATIONSHIP_MANAGER, ROLES.PARTNER, ROLES.OFFICE_ADMIN, ROLES.VIEW_ONLY,ROLES.SALES_LIMITED]

const USERS_PAGE_ACCESS_USERS: string[] = [ROLES.OFFICE_ADMIN, ROLES.SUPER_ADMIN, ROLES.RELATIONSHIP_MANAGER, ROLES.OFFICE_MANAGER]

const FIELDS_PAGE_ACCESS_USERS: string[] = [ROLES.SUPER_ADMIN]

const OFFICES_PAGE_ACCESS_USERS: string[] = [ROLES.OFFICE_ADMIN, ROLES.SUPER_ADMIN, ROLES.RELATIONSHIP_MANAGER]

const AUDIT_PAGE_ACCESS_USERS: string[] = [ROLES.SUPER_ADMIN]

const API_INTEGRATIONS_PAGE_ACCESS_USERS: string[] = [ROLES.UNDER_WRITER]

const Header = (props: HeaderProps) => {
  const history = useHistory();
  const { config, setConfig }: any = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  
  const [selectedFile, setSelectedFile] = useState(null)
  const [showFNModal, setShowFNModal] = useState(false)
  const [merchantToken, setMerchantToken] = useState('')
  const [mobileMenuSidebar, setMobileMenuSidebar] = useState(false);
  const [mobilesidebarFooter, setMobilesidebarFooter] = useState(false);
  const [appType, setAppType] = useState('ActiveApps'); 

  const role = sessionStorage.getItem('role')
  const email = sessionStorage.getItem('email')
  const iris_enabled = sessionStorage.getItem('iris_enabled')
  const feenavigator_enabled = sessionStorage.getItem('feenavigator_enabled')
  let user_name = sessionStorage.getItem('user_name')
  let uid = sessionStorage.getItem('user_guid')

  const isMobile = useCheckMobileScreen();
  const isTab = useCheckTabScreen();
  
  useEffect(()=>{
    if(mobileMenuSidebar){
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  return () => {
    if(document.body.style.overflow && document.body.style?.overflow === 'hidden'){
      document.body.style.removeProperty('overflow');
    }
  }
},[mobileMenuSidebar])

  useEffect(() => {
    setName(user_name || '')
    const refreshProfile = async (guid: string) => {
      const data = {
        api: api.users.getByGUID,
        urlParam: guid,
      };
      const profiledata = await backend.fetch(data);

      const token = await auth.getToken()
      const decodedToken: any  = await getDecodedToken(token)

      if(decodedToken.super_user){
        if(decodedToken.access_client_id !== config.selectedClientId){
          sessionStorage.setItem("super_user", 'true')
          sessionStorage.setItem("selectedClientId", decodedToken.access_client_id)
          setConfig({
            ...config,
            selectedClientId: decodedToken.access_client_id,
            default_config_fe: config?.client_config_fe
          })
        }
      }
      
      const first_name = VITE_REACT_APP_BACKEND_MYSQL ? profiledata.user_name_first : profiledata?.name?.first_name
      const last_name = VITE_REACT_APP_BACKEND_MYSQL ? profiledata.user_name_last : profiledata?.name?.last_name

      if (profiledata) {
        let { feenavigator_enabled } = profiledata;

        feenavigator_enabled = VITE_REACT_APP_BACKEND_MYSQL ? Number(feenavigator_enabled) : feenavigator_enabled;

        const nameString = `${first_name} ${last_name}`;
        setName(nameString);
        // setUid(profiledata?.guid);
        sessionStorage.setItem("feenavigator_enabled", feenavigator_enabled.toString() || false);
      }
    };

    const customTokenValidation = async (tokenId: string) => {

      let request = {
        api: api.merchant.verifyToken,
        queryParam: { token: tokenId }
      }

      let tokenInfo = await backend.fetchUnprotected(request)
      if (tokenInfo.status) {
        const token: any = await getDecodedToken(tokenInfo.token)
        sessionStorage.setItem("user_name", token?.uid);
        setName(token?.uid || '')
      }
    };

    const user: any = auth.getUser();

    if (user) {
      const { uid, email } = user;
      // setCurrentPage(props.page);
      if (email) {
        refreshProfile(uid);
      } else {
        setName(uid);
      }
    }

    const params = new URLSearchParams(history.location.search);
    const tokenID: any = params.get("token");

    if (tokenID) {
      setMerchantToken(tokenID)
      customTokenValidation(tokenID);
    }
    setAppType(props.listType ? 'ActiveApps' : 'ArchivedApps')
  }, [props.page, history,props.listType]);

  const signOut = async () => {
    try {
      setLoading(true);
      await auth.doSignOut();
      const clientId = sessionStorage.getItem("clientId")
      sessionStorage.clear();
      if (!!clientId) {
        sessionStorage.setItem("clientId", clientId)
      }
      localStorage.clear();
      setConfig({
        ...config,
        accessible_clients: [],
        user_roles_id : null,
        selectedClientId: config?.id,
        client_config_fe: config.default_config_fe || config.client_config_fe
      })
      setLoading(false);
    } catch (err: any) {
      console.log(err);
    } finally {
      history.replace("/");
    }
  };

  const handelLogoClick = async () => {
    if (!email) {
      history.push("/");
    } else {
      history.push("/listapp");
    }
  };

  useEffect(() => {
    if((props.page === "users" && !USERS_PAGE_ACCESS_USERS.includes(role!)) ||
    (props.page === "fieldlist" && !FIELDS_PAGE_ACCESS_USERS.includes(role!)) ||
    (props.page === "offices" && !OFFICES_PAGE_ACCESS_USERS.includes(role!)) ||
    (props.page === "audit" && !AUDIT_PAGE_ACCESS_USERS.includes(role!))
    ){
      history.replace('/listapp')
    }
    if( ( props.page === 'createlink') && role === ROLES.SUPER_ADMIN ){
      history.replace('/listapp')
    }
    if( (props.page === 'startapp' || props.page === "users" || props.page === "fieldlist" || props.page === "offices") && (role === ROLES.VIEW_ONLY )){
      history.replace('/listapp')
    }
  }, [props.page])

  const onFileUpload = async () => {
    try {
      setLoading(true)

      const timeStamp: any = new Date().getTime()

      const file: any = selectedFile
      const uploadRef = ref(storage, `feenavigator/${uid}/${timeStamp}/uploads/${file.name}`);
      const uploadTask = uploadBytesResumable(uploadRef, file);

      uploadTask.on(
        "state_changed",
        (snapShot: any) => {
          console.log(snapShot);
        },
        (err: any) => {
          console.log(err);
        },
        async () => {
          const path: string = await uploadRef.fullPath

          const payload = {
            "message": {
              "data": {
                "apiType": "feenavigator",
                "apiroute": "upload statement",
                file_path: path,
                file_name: file.name,
                user_id: uid,
                upload_ts: timeStamp
              }
            }
          }
          console.log('payload :>> ', payload);

        const data = {
          api: api.integrations.testpubsub,
          payLoad: { ...payload }
        }


        const response = await backend.save(data)
        console.log('response :>> ', response);

          notification.success({className: 'fn-success-notification', message: "", description: "Statement successfully uploaded. Your results will be emailed." })
          setLoading(false)
          setShowFNModal(false)
        });
    } catch (err) {
      console.log('err :>> ', err);
      setLoading(false)
      notification.error({ message: "", description: "Failed uploading Statement. Please try again." })
    } finally {
      
      setSelectedFile(null)
    }
  }

  const statementAnalysisIso = async () => {

    const iso_secret_key = "eAuSipynpBxAvuuLtKKCVFHm9JSVCQRP"
    const destination = "/isoamp/#/statement_upload/new";

    try {
      let data: any = {
        api: api.integrations.generateUrlIso,
      };
      const response: any = await backend.fetch(data);

      let userData: any = response

      const {user_email, name} = userData

      const message = {
        email: user_email,
        name: name,
        destination: destination,
      };
    
      //message hex encoded
      const encoded_message = JSON.stringify(message);
      const encoder = new TextEncoder();
      const uint8Array = encoder.encode(encoded_message);
      const hexString = Array.from(uint8Array, (byte) =>
        byte.toString(16).padStart(2, "0")
      ).join("");
    
      //Unix time
      let unix_time = Math.floor(new Date().getTime() / 1000);
    
      //version of app
      const version = 1;
    
      //The secret key from your Login Link Secret Key in the Admin
      let secret_key = iso_secret_key;
      const hmac = CryptoJS.HmacSHA256(
        `${hexString}${unix_time}${version}`,
        secret_key
      );
    
      //signature
      const signature = CryptoJS.enc.Hex.stringify(hmac);
    
      //URL
      const url = `https://trinitypayments.isoquote.com/login_via_link?m=${hexString}&t=${unix_time}&v=${version}&s=${signature}`;
    
      window.open(url, '_blank');
    } catch (error) {
      console.error("An error occurred during the API request:", error);
    }  
  };
  
  const PAGES = {
    LIST_APP: "listapp",
    USERS: "users",
    OFFICES: "offices",
    API_INTEGRATIONS: "apiintegrations",
    CREATE_LINK: "createlink",
  }

  const pagesHavingFilter = [
    PAGES.LIST_APP,
    PAGES.USERS,
    PAGES.OFFICES,
    PAGES.API_INTEGRATIONS,
    PAGES.CREATE_LINK
  ];

  const hamburgerComponent = () => {
    const showFilter = props.page && !!(pagesHavingFilter.find(pg => pg === props.page));
    return <div className="mobile-menu">
      {showFilter && <span className="filter-header-mob" onClick={() => {setMobilesidebarFooter(true);setMobileMenuSidebar(true);}} >
        <img src={filterIcon} alt="filter"/>
      </span>}
      <span className="circle-name ham-name" onClick={() => {setMobileMenuSidebar(true);setMobilesidebarFooter(false);}} >{name.split(' ').map(x=>x.charAt(0)).join('')}</span>
    </div>
  }

  const platformAdminUsers = [
    `${ROLES.SUPER_ADMIN}`
  ];

  const renderPageSpecificHeader = (logoSource:any) => {
    const role: string = sessionStorage.getItem('role') || '';
    return (
      <>
      <div className="header" style={{background: config?.client_config_fe?.header_bg_color}}>
      <div className="logo" onClick={handelLogoClick}>
        <img src={logoSource} alt="logo"/>
        </div>
      {isMobile ? <>{hamburgerComponent()}</>: ''}

          <div className="menu-items">
            <div className="menu">
              <ul className="ipad-header-btn">
                {!!role && API_INTEGRATIONS_PAGE_ACCESS_USERS.includes(role) &&
                  <li className="ipad-btns">
                    <HeaderMenuButton
                      pageName='apiintegrations'
                      currentPage={props.page}
                      pageDisplayName="API INTEGRATIONS"
                      config={config}
                    />
                  </li>
                }
                {!!role && FIELDS_PAGE_ACCESS_USERS.includes(role) &&
                  <li className="ipad-btns">
                    <HeaderMenuButton
                      pageName='fieldlist'
                      currentPage={props.page}
                      pageDisplayName="FIELDS LIST"
                      config={config}
                    />
                  </li>
                }
                {!!role && OFFICES_PAGE_ACCESS_USERS.includes(role) &&
                  <li className="ipad-btns">
                    <HeaderMenuButton
                      pageName='offices'
                      currentPage={props.page}
                      pageDisplayName="OFFICES LIST"
                      config={config}
                    />
                  </li>
                }
                {!!role && USERS_PAGE_ACCESS_USERS.includes(role) &&
                  <li className="ipad-btns">
                    <HeaderMenuButton
                      pageName='users'
                      currentPage={props.page}
                      pageDisplayName="USERS LIST"
                      config={config}
                    />
                  </li>
                }
                {!!role && SEND_APP_ACCESS_USERS.includes(role) &&
                  <li className="header-ipad-btns">
                    <HeaderMenuButton
                      pageName='createlink'
                      currentPage={props.page}
                      pageDisplayName={role === ROLES.VIEW_ONLY || role === ROLES.SALES_LIMITED ? 'VIEW LINK' : 'CREATE LINK'}
                      config={config}
                    />
                  </li>
                }
                {!!role && START_APP_ACCESS_USERS.includes(role) &&
                  <li className="header-ipad-btns">
                    <HeaderMenuButton
                      pageName='startapp'
                      currentPage={props.page}
                      pageDisplayName="START APP"
                      config={config}
                    />
                  </li>
                }
                {!!role &&
                  <li className="header-ipad-btns">
                    <HeaderMenuButton
                      pageName='listapp'
                      currentPage={props.page}
                      pageDisplayName="APP LIST"
                      config={config}
                    />
                  </li>

                }
                {!!role && AUDIT_PAGE_ACCESS_USERS.includes(role) &&
                  <li className="ipad-btns">
                    <HeaderMenuButton
                      pageName='audit'
                      currentPage={props.page}
                      pageDisplayName="CHANGES LOG"
                      config={config}
                    />
                  </li>
                }
              </ul>
            </div>
            <div className="navbar merchant-navbar">
              {/* {renderDropDown()} */}
              <div className="right-logout">
              <AccountMenu
                name={name}
                signOut={signOut}
                config={config}
                role={role}
                customMenuItems={((VITE_REACT_APP_PLATFORM_ADMIN === 'true') && platformAdminUsers.includes(role) && config.selectedClientId == VITE_REACT_APP_DEFAULT_CLIENT_ID) ? [
                  { label: "Platform Admin", onclick: () => history.replace('/platformadmin/onboarding') }
                ] : []}
              />
              </div>
              {/* <div className="user-name" style={{ color: config?.client_config_fe?.header_text_color }}>Hi {name}</div> */}
              {hamburgerComponent()}
              {!!role && (VITE_REACT_APP_BACKEND_MYSQL ? !!Number(iris_enabled) : iris_enabled === 'true') &&
                <div className="iris_button" style={{ background: config?.client_config_fe?.button_color}}>
                  <a href="https://www.portal.trinitypaysol.com/login" target="_blank" rel="noopener noreferrer">REPORTS DASHBOARD</a>
                </div>
              }
              {!!role && role !== ROLES.SUPER_ADMIN && (VITE_REACT_APP_BACKEND_MYSQL ? !!Number(feenavigator_enabled) : feenavigator_enabled === 'true') &&
                <div>
                  <button className="fn_button" style={{ background: config?.client_config_fe?.button_color}} onClick={statementAnalysisIso}>
                    STATEMENT ANALYSIS
                  </button>
                </div>
              }
              {get(config, "accessible_clients", []).length > 1 &&
                <ClientList page={props.page} currentClient={config.selectedClientId} />
              }
            </div>
          </div>
      </div>
      {isMobile && <MobileHeaderTabs role={role}/>}
      </>
    );
  };

  const renderMerchantHeader = (logoSource:any) => {
    return (
      <div className="header" style={{background: config?.client_config_fe?.header_bg_color}}>
        <div className="logo">
          <img src={logoSource} alt="logo"/>
          </div>
      <div className="menu-items merchant-menu-items">
        <div className="navbar merchant-navbar">
          {/* {renderDropDown()} */}
          <div className="right-logout">
          <AccountMenu
                  name={name}
                  signOut={signOut}
                  config={config}
                  role={role}
                />
          </div>
          {/* <div className="user-name">Hi {name}</div> */}
        </div>
      </div>
      </div>
    );
  };
  //const getTenantSpecificStyles = () => 
  const renderHeader = (tenantLogoSource:any) => {
    if (email && role && auth.isAuthenticated() && window.location.pathname !== '/') {
      return <>{renderPageSpecificHeader(tenantLogoSource)}</>;
    } else if (merchantToken && merchantToken !== '' && window.location.pathname !== '/') {
      return <>{renderMerchantHeader(tenantLogoSource)}</>;
    } else if (history.location.pathname.includes('/startapp/edit') || history.location.pathname.includes('/AL') || history.location.pathname.includes('/thankspage') || history.location.pathname.includes('/ds-return') || history.location.pathname.includes('/docupload')) {
      return (
        <div className="header" style={{background: config?.client_config_fe?.header_bg_color}}>
          <div className="logo">
            <img src={tenantLogoSource} alt="logo"/>
            </div>
          <div className="menu-items">
            <div className="navbar merchant-navbar" />
          </div>
        </div>
      );
    } else {
      return (
          <div className="logo-login" onClick={handelLogoClick}>
            <img src={tenantLogoSource}  alt="logo"/>
            </div>
      );
    }   
  };

  const uploadProps: UploadProps = {
    beforeUpload: file => {
      setLoading(true)
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        // message.error(`${file.name} is not a pdf file. Please Upload pdf file.`);
        notification.error({ className: 'fn-notification', message: "Incorrect File Format", description: `${file.name} is not a pdf file. Please Upload pdf file.` })
        setLoading(false)
      }
      return isPDF || Upload.LIST_IGNORE;
    },
    maxCount: 1,
    onChange: info => {
      console.log('info', info)
      if (info.file.status === 'done' || info.file.status === 'error') {
        setLoading(false)
      }
      if (info.fileList.length > 0) {
          const file: any = info.fileList[0].originFileObj
          setSelectedFile(file)
      } else {
        setSelectedFile(null)
      }
    },
  };
const MobileSideSortBar = () => {
  const content: any = { [PAGES.LIST_APP]: "App ID", [PAGES.USERS]: "User ID", [PAGES.OFFICES]: "Office ID", [PAGES.API_INTEGRATIONS]: "App ID", [PAGES.CREATE_LINK]: "Link ID"};
  const tag = props.page || 'x'
  if (!content.hasOwnProperty(tag)) return <></>;
  
  return (<>
    <div className="appid-order">
    <Link to={`/${tag}?sort=asc`}>{content[tag]} ascending order</Link>
    </div>
    <div className="appid-order">
      <Link to={`/${tag}?sort=desc`}>{content[tag]} descending order</Link>
      </div></>)

}
const getExistingSearchVal = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('searchTerm') || ""
}
const [searchText, setSearchText] = useState(getExistingSearchVal());

const showSearch = () => {
  const show = ['/listapp','/users','/offices','/apiintegrations', '/createlink'];
  const currentPath = window.location.pathname;
  return !!show.find(path => path === currentPath)
}
const clearSearch = () => {
  setSearchText("")
  setAppType("")
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete("searchTerm");
  urlParams.delete("appType");
  window.location.search = urlParams.toString();
}
const onSearch = () => {
  if (searchText) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('searchTerm', searchText);
    urlParams.set('appType', appType);
    window.location.search = urlParams.toString();
  }
  hideSideBar();
}
const hideSideBar = () => {
  setMobilesidebarFooter(false);
  setMobileMenuSidebar(false);
  
  };
  
  return (
    <div>
      <ProgressLoader loading={loading} />
      {renderHeader(config?.client_config_fe?.header_logo)}
      {showFNModal &&
          <Modal
            centered
            open={showFNModal}
            onClose={() => {
              setShowFNModal(false)
              setSelectedFile(null)
            }}
            onOpen={() => setShowFNModal(true)}
            closeOnEscape={false}
            closeOnDimmerClick={false}
          >
            <Modal.Header>
              Upload your PDF Statement here  
            </Modal.Header>
            <Modal.Content>
              <ProgressLoader loading={loading} size='small' />
              <Modal.Description>
              <div>
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined rev={undefined} />}>Upload pdf statement</Button>
                </Upload>
              </div>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={() => {
                setSelectedFile(null)
                setShowFNModal(false)
              }} color='blue'>CANCEL</Button>
              <Button onClick={onFileUpload} color='blue' disabled={!selectedFile}>UPLOAD STATEMENT</Button>
            </Modal.Actions>
          </Modal>}
          {(isMobile || isTab) && <>
            <div className={mobileMenuSidebar ? "mobile-menu-sidebar mobile-menu-sidebar-width-open" : "mobile-menu-sidebar mobile-menu-sidebar-width-closed hide-sidebar-data"}>
              <div className="back-button-container" onClick={hideSideBar}>
                <ChevronLeft />
                Back
              </div>
              <div className="mobile-menu-items">
                <div className="profile-name">
                  <span className="circle-name ipad-circle">{name.split(' ').map(x=>x.charAt(0)).join('')}</span>
                  <div className="mob-name-role">
                    <div>{name}</div>
                    <div>{role}</div>
                </div>
                </div>
                {props.page !== "listapp" && showSearch() && mobilesidebarFooter && (<>
                <input placeholder="search.." 
                onKeyUp={e => {
                  console.log("key:", e.key);if (e.key === "Enter") {
                  onSearch()
                }}}
                className="sidebar-search" type="text" value={searchText} onChange={(e)=> setSearchText(e.target.value)} />
                <div className="search-buttons">
                  <button onClick={onSearch}>search</button>
                  <button onClick={clearSearch}>clear</button>
                  </div>
                </>)
                }
                {mobilesidebarFooter && <MobileSideSortBar/>}
                {!mobilesidebarFooter && (<div>
              {!!role && role !== ROLES.SUPER_ADMIN && feenavigator_enabled === 'true' &&
                <a>
                  <div onClick={() => {
                    statementAnalysisIso(); setMobileMenuSidebar(false); 
                  }}>
                    Statement Analysis
                </div></a>
              }
               {!!role && iris_enabled === 'true' && <a href="https://www.portal.trinitypaysol.com/login" target="_blank" rel="noopener noreferrer">Reports Dashboard</a>}
               {!!role && OFFICES_PAGE_ACCESS_USERS.includes(role) &&<Link to="/offices" className={props.page === "offices" ? "active-mobile" : ""}>Offices List</Link>}
               {!!role && USERS_PAGE_ACCESS_USERS.includes(role) &&<Link to="/users" className={props.page === "users" ? "active-mobile" : ""}>Users List</Link>}
               {!!role && AUDIT_PAGE_ACCESS_USERS.includes(role) && <Link to="/audit" className={props.page === "audit" ? "active-mobile" : ""}>Changes Log</Link>} 
               {!!role && FIELDS_PAGE_ACCESS_USERS.includes(role) && <Link to="/fieldlist" className={props.page === "fieldlist" ? "active-mobile" : ""}>Fields List</Link>}
               {!!role && API_INTEGRATIONS_PAGE_ACCESS_USERS.includes(role) && <Link to="/apiintegrations" className={props.page === "apiintegrations" ? "active-mobile" : ""}>API Integrations</Link>}
                <a role='button' onClick={signOut}>Log Out</a>
                </div> )}
              </div>
            </div>
            <div className={mobileMenuSidebar ? "overlay-layer" : "overlay-layer-closed"} onClick={() => setMobileMenuSidebar(false)}></div>
          </>}

    </div>
  );
};

export default React.memo(Header)
